export {
	default,
	MIN_ANSWER_COUNT,
	TOO_LARGE_PERCENTAGE,
	TOO_SMALL_PERCENTAGE,
} from './ProductFit';
